export const LOAD_BOARDS = "LOAD_BOARDS";
export const ERROR_BOARDS = "ERROR_BOARDS";